<template>
  <GenericListSubHeader :text="unit.Name" :previewable="/*!!unit.Id*/ false" :showCheckbox="multiple"
    :isChecked="unitIsChecked()" :toggleCheckbox="() => toggleSelectedUnit()"
    @PrimaryClick="multiple ? toggleSelectedUnit() : toggleHideByUnitId()"
    @MiddleClick="unit.Id ? openInNewTab() : null">
    <v-row no-gutters align="center">
      <v-col class="px-3" cols="0">
        {{ unit.Name }}
      </v-col>
      <v-col cols="auto">
        <v-btn icon class="mx-1" @click.stop="toggleHideByUnitId()">
          <v-icon v-text="!hideByUnitId(unit.Id) ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </GenericListSubHeader>
</template>


<script>
import GenericListSubHeader from "@/components/ListItems/GenericListSubHeader.vue";

export default {
  name: 'MachineListUnitSubHeader',
  props: {
    unit: {
      type: Object,
      required: true
    },
    multiple: Boolean,
    items: Array,
    selectionFilter: {
      type: Object,
      required: true
    },
    setSelectionFilterFunc: {
      type: Function,
      required: true
    }
  },
  components: {
    GenericListSubHeader,
  },

  data() {
    return {};
  },

  methods: {
    openInNewTab() {
      let newPageRoute = this.$router.resolve({ name: 'ViewUnit', params: { unitId: this.unit.Id } });
      window.open(newPageRoute.href, "_blank");
    },

    unitIsChecked() {
      const unitInMap = this.selectionFilter.unitIdMap?.[this.unit.Id];
      if (!unitInMap) {
        return this.selectionFilter.SelectAll;
      }
      else {
        return !this.selectionFilter.SelectAll;
      }
    },

    toggleSelectedUnit() {
      var copy = Object.assign({}, this.selectionFilter);

      //set unit id to correct filter value
      var unitIdMap = Object.assign({}, copy.unitIdMap);
      const unitId = this.unit.Id;
      const boolVal = !unitIdMap[unitId];
      unitIdMap[unitId] = boolVal;
      copy.unitIdMap = unitIdMap;
      const listKey = copy.SelectAll ? 'ExcludedUnitIdList' : 'UnitIdList';
      copy[listKey] = Object.keys(unitIdMap)
        .filter(id => unitIdMap[id]) //only where value is true
        .map(id => id === 'null' ? null : id); //if present replace key 'null' (string key) with null (value)

      //clear any individually set items from group
      var loadedIds = this.items.map(m => m.Id);
      var itemMap = Object.assign({}, copy.prependItemIdMap);
      var eItemMap = Object.assign({}, copy.excludeItemIdMap);
      loadedIds.forEach(k => {
        delete itemMap[k];
        delete eItemMap[k];
      });
      copy.prependItemIdMap = itemMap;
      copy.PrependItemIdList = Object.keys(itemMap);
      copy.excludeItemIdMap = eItemMap;
      copy.ExcludeItemIdList = Object.keys(eItemMap);

      this.setSelectionFilterFunc(copy);
    },

    toggleHideByUnitId() {
      var copy = Object.assign({}, this.selectionFilter);
      var hideByUnitId = Object.assign({}, copy.hideByUnitId);
      hideByUnitId[this.unit.Id] = !hideByUnitId[this.unit.Id];
      copy.hideByUnitId = hideByUnitId;
      this.setSelectionFilterFunc(copy);
      this.$emit('checkScroll'); //check scroll in case the list now is smaller than viewport
    },

    hideByUnitId(unitId) {
      return this.selectionFilter.hideByUnitId?.[unitId] ?? false;
    },
  },

  computed: {

  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>